// extracted by mini-css-extract-plugin
export default {"questionColumn":"BTcBV7o1WXWuyLcVQZWI","answerColumn":"KzjHZ7X3fdjh6mH8fD_w"};